/* eslint-disable max-len */
const Profile = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 32 32'>
    <circle cx='16' cy='16' r='15' stroke='currentColor' strokeWidth='2' />
    <path fill='currentColor' fillRule='evenodd' clipRule='evenodd' d='M19.3 13.3a3.3 3.3 0 1 1-6.6 0 3.3 3.3 0 0 1 6.6 0zm-.2 4.4a5.3 5.3 0 1 0-6.2 0A10 10 0 0 0 7 22.6a1 1 0 1 0 1.8.9 8 8 0 0 1 7.1-4.3 8 8 0 0 1 7.1 4.3 1 1 0 1 0 1.8-1 10 10 0 0 0-5.8-4.8z' />
  </svg>
);

export default Profile;
